import React, { useState, useEffect, useRef } from "react";
import DefaultInput from "../../inputs/defaultInput";
import { HiCheck, HiX } from "react-icons/hi";

const InlineCellEditor = ({ value, field, onSave, onCancel }) => {
  const [editValue, setEditValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  const handleSave = () => {
    onSave(editValue);
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <div className="flex items-center gap-1">
      <input
        ref={inputRef}
        type="text"
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onKeyDown={handleKeyDown}
        className="flex-1 px-2 py-1 text-sm border border-theme rounded focus:outline-none focus:ring-1 focus:ring-theme"
        aria-label={`Edit ${field}`}
      />
      <button
        type="button"
        onClick={handleSave}
        className="p-1 text-success-600 hover:text-success-700"
        aria-label="Save"
      >
        <HiCheck className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={handleCancel}
        className="p-1 text-error-600 hover:text-error-700"
        aria-label="Cancel"
      >
        <HiX className="w-4 h-4" />
      </button>
    </div>
  );
};

export default InlineCellEditor;

